import { reroll } from "../components/PageSetRouter";

export default {
  homepageViaSocialRoute(socialShareSource: string) {
    reroll(`/s/${socialShareSource}`);
  },
};
